import { render, staticRenderFns } from "./BusinesOffers.vue?vue&type=template&id=2fc19b8a&scoped=true&"
import script from "./BusinesOffers.vue?vue&type=script&lang=js&"
export * from "./BusinesOffers.vue?vue&type=script&lang=js&"
import style0 from "./BusinesOffers.vue?vue&type=style&index=0&id=2fc19b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc19b8a",
  null
  
)

export default component.exports